import { AfterContentInit, Component, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HomeService } from '../../services/home.service';

@Component({
  selector: 'app-done',
  templateUrl: './done.component.html',
  styleUrls: ['./done.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DoneComponent implements AfterContentInit {
  private smartValidationLink: string;
  public header_h3_1: string;
  public variables = {};

  constructor(public transSvc: TranslateService,
    public homeSvc: HomeService) {

    this.smartValidationLink = this.homeSvc.svSiteUrl + '/' + this.homeSvc.languageCode + '/' + this.homeSvc.phoneNumber;
    this.variables = { link: this.smartValidationLink };

  }

  ngAfterContentInit(): void {
    window.parent.postMessage('pxsNpDonePageLoaded', '*');
    //this.transSvc.use(this.HomeSvc.languageCode);
    this.transSvc.get('done.header_h3_1', this.variables).subscribe((text: string) => {
      this.header_h3_1 = text;
    });
  }
}
